import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../../../dic';
import { GN } from '../../../../gn';

/**
 * Generated class for the EditagrmechanPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editagrmechan',
  templateUrl: 'editagrmechan.html',
})
export class EditagrmechanPage {
  cb: any
  id = -1
  name = ''
  code = ''
  invnum = ''
  range = null
  operationid = 0
  operations = []
  _ounit = 0

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
    this.id = this.navParams.get('id')
    this.name = navParams.get('name')
    this.code = navParams.get('code')
    this.invnum = navParams.get('invnum')
    this.range = navParams.get('range')
    this.operationid = navParams.get('operationid')
    this.operations = navParams.get('operations')
    this.cb = navParams.get('cb')
    this._ounit = navParams.get('orgid')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditagrmechanPage');
  }

  doSave(_id, _name, _op, _tmp, _operationid, _code, _invnum, _orgid) {
    var _that = this
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      id: this.gn.crypt(_id),
      name: this.gn.crypt(_name),
      code: this.gn.crypt(_code),
      invnum: this.gn.crypt((_invnum == null || _invnum == 'null') ? '' : _invnum),
      op: this.gn.crypt(_op),
      tmp: this.gn.crypt(_tmp),
      type: this.gn.crypt('ConnectionMechanization'),
      operationid: this.gn.crypt(_operationid),
      orgid: this.gn.crypt(_orgid)
    }
    this.gn._Post('/api/gn/addcolutures', _dat, function (_data) {
      _that.cb()
      _that.navCtrl.pop()
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/agrmechan/editagrmechan/editagrmechan.ts